// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function inclusion_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var default_title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "default_title"), null));
  if (default_title.TAG === /* Ok */0) {
    var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
    if (amount.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                default_title: default_title._0,
                amount: amount._0
              }
            };
    }
    var e = amount._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".amount" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = default_title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".default_title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function settlement_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
  if (amount.TAG === /* Ok */0) {
    var settlement_ts = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "settlement_ts"), null));
    if (settlement_ts.TAG === /* Ok */0) {
      var default_title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "default_title"), null));
      if (default_title.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  amount: amount._0,
                  settlement_ts: settlement_ts._0,
                  default_title: default_title._0
                }
              };
      }
      var e = default_title._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".default_title" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = settlement_ts._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".settlement_ts" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = amount._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".amount" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function earning_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var amount = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
  if (amount.TAG === /* Ok */0) {
    var _type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
    if (_type.TAG === /* Ok */0) {
      var default_title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "default_title"), null));
      if (default_title.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  amount: amount._0,
                  _type: _type._0,
                  default_title: default_title._0
                }
              };
      }
      var e = default_title._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".default_title" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = _type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".type" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = amount._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".amount" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function earning_details_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var earnings = Decco.listFromJson(earning_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "earnings"), null));
  if (earnings.TAG === /* Ok */0) {
    var fare_inclusions = Decco.listFromJson(inclusion_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare_inclusions"), null));
    if (fare_inclusions.TAG === /* Ok */0) {
      var settlements = Decco.listFromJson(settlement_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "settlements"), null));
      if (settlements.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  earnings: earnings._0,
                  fare_inclusions: fare_inclusions._0,
                  settlements: settlements._0
                }
              };
      }
      var e = settlements._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".settlements" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = fare_inclusions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".fare_inclusions" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = earnings._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".earnings" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var earning_details = earning_details_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "earning_details"), null));
  if (earning_details.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              earning_details: earning_details._0
            }
          };
  }
  var e = earning_details._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".earning_details" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  inclusion_decode ,
  settlement_decode ,
  earning_decode ,
  earning_details_decode ,
  t_decode ,
  
}
/* No side effect */
